import 'bootstrap/dist/css/bootstrap.min.css';
import $ from 'jquery';
import Popper from 'popper.js';
import 'bootstrap/dist/js/bootstrap.bundle.min';

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.jsx';
import reportWebVitals from './reportWebVitals.jsx';
import { BrowserRouter } from "react-router-dom"
import { LoadingProvider } from './components/LoadingContext.jsx';
import { FilterProvider } from './components/FilterContext.jsx';
import { EventProvider } from './components/EventContext.jsx';
import { AuthProvider } from './components/AuthContext.jsx';
import LoginProvider from './components/LoginContext.jsx';
import LocationProvider from './components/LocationContext.jsx';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true
      }}
    >
      <LoginProvider>
        <AuthProvider>
          <LoadingProvider>
            <EventProvider>
              <FilterProvider>
                <LocationProvider>
                  <App />
                </LocationProvider>
              </FilterProvider>
            </EventProvider>
          </LoadingProvider>
        </AuthProvider>
      </LoginProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
